import Modal from "@mui/material/Modal";
import { TKIconClose, TKIconLogoIcon } from "assets/images/svgs";

const TKModal = ({ open, onClose, children, noHeader }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="bg-[#FAFAFA] outline-0 w-[90%] mt-[30%] lg:mt-[10%] mx-auto md:w-[70%] lg:w-[45%] pb-6 py-4 border-0 rounded-lg shadow-lg flex flex-col outline-none focus:outline-0">
        {!noHeader && (
          <div className="border-b flex justify-between px-[20px] py-[10px]">
            <div className="flex gap-3">
              <TKIconLogoIcon />
              <p className="text-[#213874] font-semibold">Truekeepers</p>
            </div>
            <TKIconClose className="cursor-pointer" onClick={onClose} />
          </div>
        )}
        <div className="px-6 overflow-y-auto max-h-[500px]">{children}</div>
      </div>
    </Modal>
  );
};

export default TKModal;
